import 'animate.css/animate.min.css';
import BrowserSupport from './assets/browserSupport.js';
BrowserSupport.isIE10();

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import { sync } from 'vuex-router-sync';
import Loading from '@/components/phila-ui/Loading';
import VueGtag from "vue-gtag";
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { ResponsiveHelpers } from '@phila/phila-ui';

Vue.use(ResponsiveHelpers);

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    environment: process.env.NODE_ENV,
    dsn: 'https://36a12abc43f04b008787c94d8b6146f0@o418767.ingest.sentry.io/5324344',
    integrations: [ new VueIntegration({
      Vue, attachProps: true,
    }) ],
  });
}


Vue.use(VueGtag, {
  config: { id: "UA-860026-1" },
  enabled: process.env.NODE_ENV === 'production' || false,
}, router);

sync(store, router);

Vue.component('Loading', Loading);

/** GLOBAL APP SETTINGS STARTS HERE */
require('./plugins/setup-validator');
require('./config/global-components');

// Set the router available in the store
store.$router = router;

// Setup modals
import VModal from 'vue-js-modal';
Vue.use(VModal, {
  injectModalsContainer: true,
  dynamic: true,
  dynamicDefaults: { clickToClose: false },
  height: 'auto',
  scrollable: true,
  adaptive: true,
});

// Setup the nice dayjs library
import dayjs from '@/plugins/dayjs';
Vue.use(dayjs, { store });

// Setting Up a Simple Cache library
import sCache from '@/plugins/simple-cache';
Vue.use(sCache, { store });

//Setting Up Axios
import AxiosSetter from './plugins/axios-setter';
Vue.use(AxiosSetter, { store });

//Setting Up Toast
import notifications from './plugins/toast';
Vue.use(notifications, { store });

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === 'development' || false;


const clonedeep = require('lodash.clonedeep');

/** GLOBAL APP SETTINGS ENDS HERE */
Vue.mixin({
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.name;
    });
  },
  computed: {
    isLoading2 () {
      return this.$store.loading;
    },
  },
  methods: {
    fileDownload (url) {
      const link = document.createElement('a');
      link.href = url;
      link.click();
    },
    formatDate (date, format) {
      if (!date) {
        return this.$dayjs().format(format || 'MM/DD/YYYY');
      }
      return this.$dayjs(date).format(format || 'MM/DD/YYYY');
    },
    cloneObj (obj) {
      return clonedeep(obj);
    },
  },
});

/**
 * SET THE TOKEN TO THE STORE BEFORE START THE APP
 */
store.commit('login/setToken');

/**
 * Set fetch for the App.vue
 */

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
